import { Base64 } from "js-base64";
import { IInteractionMetadata } from "../interfaces/IInteraction";

export interface IScormSlideConfiguration {
  id: string;
  title?: string;
  type?: string;
  exit?: any;
  package?: string;
  data?: any;
  metadata?: IInteractionMetadata;
  previousAttempt?: any;
  challenge_configuration?: any;
}

export default class Scorm {
  private _id: string;
  private _type: string;
  private _state: any;
  private _configuration: IScormSlideConfiguration;
  private _scormData: any;

  get state(): Object {
    return this._state || {};
  }
  set state(state: Object) {
    this._state = state;
  }

  constructor(
    id: string,
    type: string,
    conf: IScormSlideConfiguration,
    state: any,
  ) {
    this._configuration = conf;
    this._id = id;
    this._type = type;
    this._state = state;
    if (state && state.scormEncodedData) {
      var parsedData = JSON.parse(Base64.decode(state.scormEncodedData));
      if (parsedData.scormData) {
        this._scormData = parsedData.scormData;
      }
    }
  }

  renderSlides(): Array<IScormSlideConfiguration> {
    var slide = {
      id: this._id,
      data: this._configuration,
      metadata: {
        id: this._configuration.id,
        friedrichType: "Scorm",
        friedrichId: this._id,
        index: 0,
        questions: [],
      },
      previousAttempt: this._scormData,
      type: "scorm",
    };
    return [slide];
  }

  reduceState(interaction: Object): Object {
    this.state = {
      scormEncodedData: Base64.encode(JSON.stringify(interaction)),
    };
    return this.state;
  }
}

module.exports = Scorm;
